type Filelike = File | MediaAsset;

export default (file1: Filelike | null, file2: Filelike | null) => {
  if (isFile(file1) && isFile(file2)) {
    return file1.name === file2.name &&
      file1.size === file2.size &&
      file1.lastModified === file2.lastModified;
  }
  else if (!isFile(file1) && !isFile(file2) && file1 && file2) {
    return file1.id === file2.id;
  }
  return false;
};
